// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "todos4" + "." + "ca20456c" + ".chunk.css";
};